import { action, API, controller } from "api";
import { Select } from "controls";
import React, { useEffect, useState } from "react";

const SelectOutlet = ({ handleInpChg, values, setValues }) => {
  const [outlets, setOutlets] = useState([]);

  useEffect(() => {
    API(controller.Outlet + action.GetLabels).get((res) => {
      if (res.status === 200 && res.result?.length > 0) {
        setOutlets([...res.result]);
        setValues((j) => ({ ...j, outletId: res.result[0].id }));
      }
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (values.outletId) {
      var selOutlet = outlets.find((j) => j.id === values.outletId);
      setValues((j) => ({ ...j, outletName: selOutlet?.label ?? "" }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.outletId]);

  return (
    outlets.length > 1 &&
    values.outlet && (
      <Select
        onChange={handleInpChg}
        label="Outlet"
        name="outletId"
        value={values.outletId}
        options={outlets}
        required
      />
    )
  );
};

export default SelectOutlet;
